// extracted by mini-css-extract-plugin
export default {"knowAbout":"KnowAbout_knowAbout__tyG2-","knowAbout__ul":"KnowAbout_knowAbout__ul__qB7s8","knowAbout__ul__li":"KnowAbout_knowAbout__ul__li__u9Zwl"};